<template>
  <custom-tab
    content-class="mt-3"
    nav-class="nav-vue-underline"
    no-nav-style
    @input="onChangeTab"
  >
    <div class="px-md-3">
      <custom-tab-item title="Información de Requisición">
        <div class="bg-white rounded mt-md-4">
          <requisition-equipments :item="item" />
        </div>
      </custom-tab-item>
      <custom-tab-item title="Documentos">
        <div class="bg-white rounded mt-md-4">
          <requisition-documents :item="item" />
        </div>
      </custom-tab-item>
      <custom-tab-item title="Historial de Bitácora">
        <div class="bg-white rounded mt-md-4">
          <binnacle-history :history="binnacle.history" />
        </div>
      </custom-tab-item>
    </div>
  </custom-tab>
</template>

<script>
import { CustomTab, CustomTabItem } from 'custom-tabs';
import apiService from '@/services/api/requisitionmanagment.api';
import BinnacleHistory from '../../referralAndEquipment/components/BinnacleHistory.vue';
import RequisitionDocuments from './RequisitionDocuments';
import RequisitionEquipments from './RequisitionEquipments';

const TABS = {
  REQUISITION_INFORMATION: 0,
  REQUISITION_DOCUMENT: 1,
  BINACLE_HISTORY: 2,
};

export default {
  name: 'RequisitionTabs',
  components: {
    CustomTab,
    CustomTabItem,
    BinnacleHistory,
    RequisitionDocuments,
    RequisitionEquipments,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    tabIndex: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      binnacle: {
        pageSize: 2,
        totalItemCount: 0,
        history: [],
      },
    };
  },
  mounted() {
    this.onChangeTab(TABS.REQUISITION_INFORMATION);
  },
  methods: {
    onChangeTab(key) {
      this.$emit('onTabChanged', key);
      switch (key) {
        case TABS.BINACLE_HISTORY:
          this.binnacle.pageSize = 2;
          this.handlerLoadBinacle();
          break;

        default:
          break;
      }
    },
    async handlerLoadBinacle() {
      const payload = {
        peiAtRequisitionId: this.item.id,
      };
      const { data } = await apiService.getBinnacle(payload).catch((error) => {
        this.ShowToast('Error', error?.response?.data.message, 'error');
      });
      if (data) {
        this.binnacle.history = data;
      }
    },
    handlerLoadMore() {
      this.binnacle.pageSize == 1
        ? (this.binnacle.pageSize = 2)
        : (this.binnacle.pageSize += 2);
      this.handlerLoadBinacle();
    },
  },
};
</script>

<style lang="scss" scoped></style>
